// extracted by mini-css-extract-plugin
module.exports = {"title-box":"TitleBox_title-box__1SlR7"};